<template>
  <div>
    <menu-top/>


    <v-main>
      <div id="politica-cookies">

        <section>
          <v-container>
            <v-row justify="center">
              <v-col cols="12" md="10">
                <h1 class="mt-10 mb-6">POLÍTICA DE COOKIES</h1>

                <h2>¿Qué son las cookies?</h2>
                <p>
                  Una cookie es un pequeño archivo de texto que un sitio web almacena en el
                  navegador del usuario cuando lo visita. Las cookies permiten que la web
                  recuerde información sobre la visita, como el idioma preferido u otras
                  opciones, con el fin de facilitar la navegación y hacerla más útil.
                </p>

                <h2>¿Quién es el responsable del tratamiento?</h2>
                <p>
                  El responsable del uso de cookies de este sitio web es
                  <strong>GESTORIA RIOLA, S.L.</strong>, con CIF B43785096 y domicilio en
                  Rambla Nova nº 110, 2º 2ª, 43001 Tarragona. Puedes contactar con nosotros en
                  <a href="mailto:riola@gestoriariola.com">riola@gestoriariola.com</a>.
                </p>

                <h2>¿Qué tipos de cookies utiliza esta web?</h2>

                <h3>1. Cookies técnicas o necesarias</h3>
                <p>
                  Son imprescindibles para el correcto funcionamiento del sitio web y no
                  pueden desactivarse. Permiten la navegación por la página, el uso de sus
                  funciones y recordar tus preferencias, como el estado de aceptación de esta
                  política de cookies. No requieren consentimiento y no almacenan información
                  con fines publicitarios.
                </p>

                <h3>2. Cookies de análisis o medición</h3>
                <p>
                  Nos permiten conocer cómo interactúan los usuarios con la web (páginas más
                  visitadas, tiempo de navegación, en qué punto se abandona un formulario) con
                  el fin de mejorar nuestros servicios. <strong>Estas cookies no se instalan y
                  los scripts que las generan no se descargan hasta que aceptas su uso en el
                  banner de cookies.</strong> Si no aceptas, tu navegador no llega a conectarse
                  con estos proveedores.
                </p>
                <p>Los servicios que utilizamos son:</p>
                <ul>
                  <li>
                    <strong>Google Analytics 4</strong> (Google Ireland Limited): estadísticas
                    de uso agregadas. La dirección IP se trunca y no se utiliza para
                    identificarte.
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener">Política de privacidad de Google</a>.
                  </li>
                  <li>
                    <strong>Microsoft Clarity</strong> (Microsoft Corporation): mapas de calor y
                    grabación de la sesión de navegación, para ver dónde se atascan los
                    usuarios. Está configurado para ocultar automáticamente el contenido de los
                    campos de los formularios, de modo que los datos que escribas
                    <em>no</em> quedan registrados.
                    <a href="https://privacy.microsoft.com/es-es/privacystatement" target="_blank" rel="noopener">Declaración de privacidad de Microsoft</a>.
                  </li>
                </ul>

                <h3>3. Cookies de terceros</h3>
                <p>
                  Determinadas funciones de la web se apoyan en servicios de terceros (por
                  ejemplo, el envío de formularios de contacto o de solicitud de presupuesto).
                  Estos proveedores pueden instalar sus propias cookies de carácter técnico
                  para gestionar el envío de la información. En ningún caso utilizamos cookies
                  de publicidad comportamental.
                </p>

                <h2>Relación de cookies</h2>
                <v-simple-table dense class="mb-6">
                  <template v-slot:default>
                    <thead>
                      <tr>
                        <th class="text-left">Cookie</th>
                        <th class="text-left">Proveedor</th>
                        <th class="text-left">Finalidad</th>
                        <th class="text-left">Duración</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>gr-cookie-consent</td>
                        <td>Gestoría Riola</td>
                        <td>Guarda si has aceptado o rechazado las cookies (no es una cookie: se guarda en el almacenamiento local del navegador)</td>
                        <td>Hasta que borres los datos del navegador</td>
                      </tr>
                      <tr>
                        <td>_ga, _ga_*</td>
                        <td>Google Analytics 4</td>
                        <td>Distinguir usuarios y sesiones para las estadísticas de uso</td>
                        <td>2 años</td>
                      </tr>
                      <tr>
                        <td>_clck</td>
                        <td>Microsoft Clarity</td>
                        <td>Identificador de usuario para esta web</td>
                        <td>1 año</td>
                      </tr>
                      <tr>
                        <td>_clsk</td>
                        <td>Microsoft Clarity</td>
                        <td>Une las páginas vistas en una misma sesión</td>
                        <td>1 día</td>
                      </tr>
                      <tr>
                        <td>CLID, MUID, ANONCHK, MR, SM</td>
                        <td>Microsoft (clarity.ms)</td>
                        <td>Cookies de terceros del propio servicio de Microsoft</td>
                        <td>Establecida y gestionada por Microsoft</td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

                <h2>Transferencias internacionales de datos</h2>
                <p>
                  Google y Microsoft pueden tratar los datos recogidos por estas cookies en
                  servidores situados fuera del Espacio Económico Europeo, incluidos los
                  Estados Unidos. Ambos proveedores están adheridos al
                  <a href="https://www.dataprivacyframework.gov/" target="_blank" rel="noopener">EU-U.S. Data Privacy Framework</a>
                  y aplican cláusulas contractuales tipo aprobadas por la Comisión Europea. Si
                  no aceptas las cookies de análisis, ningún dato tuyo se transfiere a estos
                  proveedores.
                </p>

                <h2>¿Cómo puedes gestionar o desactivar las cookies?</h2>
                <p>
                  En tu primera visita mostramos un banner desde el que puedes
                  <strong>aceptar</strong> o <strong>rechazar</strong> el uso de cookies no
                  necesarias. Puedes cambiar de opinión en cualquier momento y con la misma
                  facilidad con la que la diste: pulsa el botón siguiente y volveremos a
                  preguntarte. Al retirar el consentimiento se borran las cookies de análisis
                  que ya estuvieran instaladas.
                </p>
                <p class="mb-6">
                  <v-btn depressed dark color="#900A30" @click="volverAPreguntar">
                    Cambiar mi decisión sobre las cookies
                  </v-btn>
                </p>
                <p>
                  Además, puedes permitir, bloquear o eliminar las cookies instaladas en tu
                  equipo configurando las opciones de tu navegador:
                </p>
                <ul>
                  <li><a href="https://support.google.com/chrome/answer/95647" target="_blank" rel="noopener">Google Chrome</a></li>
                  <li><a href="https://support.mozilla.org/es/kb/habilitar-y-deshabilitar-cookies-sitios-web-rastrear-preferencias" target="_blank" rel="noopener">Mozilla Firefox</a></li>
                  <li><a href="https://support.apple.com/es-es/guide/safari/sfri11471/mac" target="_blank" rel="noopener">Safari</a></li>
                  <li><a href="https://support.microsoft.com/es-es/microsoft-edge" target="_blank" rel="noopener">Microsoft Edge</a></li>
                </ul>
                <br>
                <p>
                  Ten en cuenta que si desactivas las cookies técnicas es posible que algunas
                  funciones del sitio web no estén disponibles o no funcionen correctamente.
                </p>

                <h2>Actualización de la política de cookies</h2>
                <p>
                  Esta política de cookies puede modificarse en función de nuevas exigencias
                  legales o cambios en el funcionamiento del sitio web. Te recomendamos
                  revisarla periódicamente. Para más información sobre el tratamiento de tus
                  datos personales, consulta nuestro
                  <a href="/aviso-legal-esp">Aviso legal y Política de privacidad</a>.
                </p>
              </v-col>
            </v-row>
          </v-container>
        </section>

        <Footer/>
      </div>
    </v-main>

    <menu-bottom/>
  </div>
</template>

<script>
  import consentimiento from '@/plugins/consentimiento';
  import MenuTop from "@/components/MenuTopEsp";
  import MenuBottom from "@/components/MenuBottomEsp";
  import { mapGetters } from 'vuex';

  import Footer from "@/components/FooterEsp";

  export default {
    name: 'PagePoliticaCookiesEsp',
    data: () => ({
    }),
    computed: {
      ...mapGetters(['collapseSidebar']),
    },
    methods: {
      /* Retirar el consentimiento tiene que ser tan facil como darlo (art. 7.3
         RGPD). Borramos las cookies de analisis, olvidamos la decision y
         recargamos: el banner vuelve a salir y no se carga nada hasta que el
         usuario decida de nuevo. */
      volverAPreguntar() {
        consentimiento.aplicar(false, false);
        consentimiento.olvidar();
        window.location.reload();
      }
    },
    components: {
      Footer,
      MenuTop,
      MenuBottom
    }
  }
</script>
